import { createContext, useContext } from "react";
// Profile picture assets
import JayantParthasarathyImage from "assets/images/people/JP_grey_min2.png";
import AlecHorrmannImage from "assets/images/people/alec_min2.png";
import AlexaHeschImage from "assets/images/people/alexa_min2.png";
import ArjunViswanathanImage from "assets/images/people/arjun2.png";
import BadriKonetyImage from "assets/images/people/badri3_9_min2.png";
import CatalinaGaleanoGarcesImage from "assets/images/people/catalina_3619_BC_4_min2.png";
import GrantSchaapImage from "assets/images/people/grant1crop_min2.png";
import IvoBabrisImage from "assets/images/people/ivo_DSC3716_min2.png";
import JeffreyMillerImage from "assets/images/people/jeff-DSC3706_min2.png";
import JiarongHongImage from "assets/images/people/jiarong_DSC3727_min2.png";
import JoelHapkeImage from "assets/images/people/joel4crop_min2.png";
import JoshDeanImage from "assets/images/people/josh_min2.png";
import JustinDrakeImage from "assets/images/people/justin_DSC3765_min2.png";
import KayleeKamalanathanImage from "assets/images/people/kaylee2_DSC3732_min2.png";
import KevinMalleryImage from "assets/images/people/kevin_min2.png";
import MahdiAhmadiImage from "assets/images/people/mahdi3_DSC3708_min2.png";
import NateBristowImage from "assets/images/people/nate2_min2.png";
import NicholasHellerImage from "assets/images/people/nick_DSC3718_min2.png";
import OliviaHedeenImage from "assets/images/people/olivia2_min2.png";
import SongyiBaeImage from "assets/images/people/songyi_min2.png";
import TonyClackoImage from "assets/images/people/tony_DSC3709_min2.png";
import TuanLeImage from "assets/images/people/tuan2crop_min2.png";
import ZikoraIzuoraImage from "assets/images/people/zikora_min2.png";
// Profile background picture assets
import Hallway070Image from "assets/images/people-backgrounds/hallway_070.jpg";
import Hallway288Image from "assets/images/people-backgrounds/hallway_288.jpg";
import Hallway416Image from "assets/images/people-backgrounds/hallway_416.jpg";
import Hallway739Image from "assets/images/people-backgrounds/hallway_739.jpg";
import Hallway849Image from "assets/images/people-backgrounds/hallway_849.jpg";

const PageContext = createContext();

/**
 * * Wrapper component that provides the page context to all components
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {Object} PageContextProvider
 */
export function PageContextProvider({ children }) {
  const pageSections = [
    {
      id: "about-section",
      title: "About",
    },
    {
      id: "platform-section",
      title: "Platform",
    },
    {
      id: "team-section",
      title: "Team",
    },
    {
      id: "media-section",
      title: "Media",
    },
    {
      id: "contact-section",
      title: "Contact",
    },
  ];

  const people = [
    {
      name: "Jayant Parthasarathy, PhD",
      position: "Founder/CEO",
      image: JayantParthasarathyImage,
      link: "https://www.linkedin.com/in/jayantparthasarathy",
    },
    {
      name: "Badri Konety, MD",
      position: "Chief Medical Officer",
      image: BadriKonetyImage,
      link: "https://www.linkedin.com/in/badrinath-konety-3645b6211",
    },
    {
      name: "Jiarong Hong, PhD",
      position: "Chief Technology Officer",
      image: JiarongHongImage,
      link: "https://www.linkedin.com/in/jiarong-hong-97849b30",
    },
    {
      name: "Justin Drake, PhD",
      position: "Chief Science Officer",
      image: JustinDrakeImage,
      link: "https://www.linkedin.com/in/justinmdrake",
    },
    {
      name: "Kaylee Kamalanathan, PhD",
      image: KayleeKamalanathanImage,
      link: "https://www.linkedin.com/in/kaylee-smith-b7977682",
    },
    /*
    {
      name: "Mahdi Ahmadi, PhD",
      image: MahdiAhmadiImage,
      link: "https://www.linkedin.com/in/mahdiahmadi61",
    },
    */
    {
      name: "Tony Clacko, MS",
      image: TonyClackoImage,
      link: "https://www.linkedin.com/in/tonyclacko",
    },
    {
      name: "Tuan Le",
      image: TuanLeImage,
      link: "https://www.linkedin.com/in/tuancanhle",
    },
    {
      name: "Catalina Galeano-Garces, PhD",
      image: CatalinaGaleanoGarcesImage,
      link: "https://www.linkedin.com/in/catalina-galeano-garc%C3%A9s-ph-d-89a73264/",
    },
    /*
    {
      name: "Nicholas Heller, PhD",
      image: NicholasHellerImage,
      link: "https://www.linkedin.com/in/neheller",
    },
    */
    {
      name: "Alec Horrmann",
      image: AlecHorrmannImage,
      link: null,
    },
    {
      name: "Nate Bristow, PhD",
      image: NateBristowImage,
      link: "https://www.linkedin.com/in/nate-bristow-557a5b76",
    },
    {
      name: "Joel Hapke",
      image: JoelHapkeImage,
      link: "https://www.linkedin.com/in/joel-hapke-81a74253",
    },
    {
      name: "Ivo Babris",
      image: IvoBabrisImage,
      link: "https://www.linkedin.com/in/ivobabris",
    },
    {
      name: "Jeffrey Miller",
      image: JeffreyMillerImage,
      link: "https://www.linkedin.com/in/jeffrey-miller-2b415011",
    },
    /*
    {
      name: "Olivia Hedeen",
      image: OliviaHedeenImage,
      link: "https://www.linkedin.com/in/olivia-hedeen-44861a221",
    },
    */
    {
      name: "Grant Schaap",
      image: GrantSchaapImage,
      link: "https://www.linkedin.com/in/grant-schaap-248175149",
    },
    {
      name: "Alexa Hesch",
      image: AlexaHeschImage,
      link: "https://www.linkedin.com/in/alexa-hesch-20b9911a2",
    },
    /*
    {
      name: "Zikora Izuora",
      image: ZikoraIzuoraImage,
      link: "https://www.linkedin.com/in/zikora-izuora-9918b22a3",
    },
    */
    /*
    {
      name: "Josh Dean",
      image: JoshDeanImage,
      link: "https://www.linkedin.com/in/joshua-dean-0424a8162",
    },
    */
    {
      name: "Kevin Mallery, PhD",
      image: KevinMalleryImage,
      link: "https://www.linkedin.com/in/kevin-mallery-phd-33a46750",
    },
    {
      name: "Songyi Bae, PhD",
      image: SongyiBaeImage,
      link: "https://www.linkedin.com/in/songyi-bae-20889424b",
    },
    {
      name: "Arjun Viswanathan",
      image: ArjunViswanathanImage,
      link: "https://www.linkedin.com/in/arjunv98",
    },
  ];

  const peopleBackgrounds = [
    { image: Hallway070Image, offsetX: "30%", offsetY: "30%" },
    { image: Hallway288Image, offsetX: "40%", offsetY: "40%" },
    { image: Hallway416Image, offsetX: "50%", offsetY: "50%" },
    { image: Hallway739Image, offsetX: "30%", offsetY: "20%" },
    { image: Hallway849Image, offsetX: "30%", offsetY: "30%" },
  ];

  const lazyLoadOffset = 2000;
  const scrollOffset = -50;
  const scrollDurationMs = 1200;

  return (
    <PageContext.Provider
      value={{
        pageSections,
        people,
        peopleBackgrounds,
        lazyLoadOffset,
        scrollOffset,
        scrollDurationMs,
      }}
    >
      {children}
    </PageContext.Provider>
  );
}

/**
 * * Hook to access the page context
 * @returns {Object} { pageSections, people, peopleBackgrounds, lazyLoadOffset, scrollOffset, scrollDurationMs }
 */
export function usePageContext() {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePageContext must be used within a PageContextProvider");
  }
  const {
    pageSections,
    people,
    peopleBackgrounds,
    lazyLoadOffset,
    scrollOffset,
    scrollDurationMs,
  } = context;
  return {
    pageSections,
    people,
    peopleBackgrounds,
    lazyLoadOffset,
    scrollOffset,
    scrollDurationMs,
  };
}
